/**
 * requestAutoConfirm — LP のリクエスト予約で「対応可能なら当店で確定してよいか」のお客様の回答（2026-10-12〜）
 *
 * LP（new-n-car ReservationForm）がリクエスト予約のときだけ json_data.data['対応可能なら確定'] に
 * 'はい'（すぐに予約確定して欲しい）/ 'いいえ'（返信メール後に検討したい。既定）を入れる。
 * 'はい' なら在庫・時間外対応の目処が立った時点で、お客様に聞き直さずに確定してよい。
 * 正: new-n-car/overview/03_reservation_engine.md §9.2
 */
import { extractJsonDataRecord } from './hotelDelivery';

export const REQUEST_AUTO_CONFIRM_KEY = '対応可能なら確定';

/** 'yes' | 'no' | null（回答なし = 即時予約や LP 以外の予約） */
export function parseRequestAutoConfirm(jsonData: unknown): 'yes' | 'no' | null {
  const data = extractJsonDataRecord(jsonData);
  const v = data ? String(data[REQUEST_AUTO_CONFIRM_KEY] ?? '').trim() : '';
  if (v === 'はい') return 'yes';
  if (v === 'いいえ') return 'no';
  return null;
}
